/* eslint-disable react/prop-types */
import { memo, useEffect, useRef, useState } from 'react'
import './ScrollList.less'

interface ScrollListProps {
  gradientColor?: string // 背景渐变色
  textColor?: string // 文字颜色
  itemHeight?: number // 每个列表项的高度
  width?: number // 列表宽度
  interval?: number // 滚动间隔时间，默认 5000ms
}

const DATA = [
  '“果宝*314”成功下单 开题报告 1 篇',
  '“果宝*855”成功下单 毕业七件套 1 套',
  '“果宝*324”成功下单 开题报告 1 篇',
  '“果宝*903”成功下单 课程论文 1 篇',
  '“果宝*801”成功下单 毕业论文 1 篇',
  '“果宝*909”成功下单 毕业七件套 1 套',
  '“果宝*893”成功下单 答辩PPT 1 篇',
  '“果宝*364”成功下单 毕业七件套 1 套',
  '“果宝*428”成功下单 答辩PPT 1 篇',
  '“果宝*675”成功下单 课程论文 1 篇',
  '“果宝*233”成功下单 文献综述 1 篇',
  '“果宝*836”成功下单 毕业论文 1 篇',
  '“果宝*947”成功下单 文献综述 1 篇',
  '“果宝*938”成功下单 降重 5 千字',
  '“果宝*833”成功下单 降AIGC 8 千字',
  '“果宝*533”成功下单 毕业七件套 1 套',
  '“果宝*031”成功下单 格式排版 1 篇',
  '“果宝*988”成功下单 降重 9 千字',
  '“果宝*857”成功下单 降AIGC 7 千字',
  '“果宝*899”成功下单 格式排版 1 篇'
]
// 复制数据以实现无缝循环
const DUPLICATE_DATA = [...DATA, ...DATA]
const ScrollList: React.FC<ScrollListProps> = ({
  gradientColor = 'linear-gradient(72.91deg, rgba(255,255,255,0.1) 3.5%,rgba(255,255,255,0.3) 17.62%,rgba(255,255,255,0.3) 80%,rgba(255,255,255,0) 100%)',
  textColor = '#ffffff',
  itemHeight = 24,
  width = 300,
  interval = 5000
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    // 设置自动滚动
    const startAutoScroll = () => {
      timerRef.current = setInterval(() => {
        setCurrentIndex(prev => prev + 1)
      }, interval)
    }
    startAutoScroll()
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
    }
  }, [interval])

  // 处理无缝跳转：当索引超过 DATA.length 时，无动画跳回 0
  useEffect(() => {
    if (currentIndex > DATA.length) {
      // 清除当前定时器
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
      // 移除过渡动画
      if (wrapperRef.current) {
        wrapperRef.current.style.transition = 'none'
      }
      // 重置索引
      setCurrentIndex(0)
      // 恢复过渡动画并重新启动定时器
      requestAnimationFrame(() => {
        if (wrapperRef.current) {
          wrapperRef.current.style.transition = ''
        }
        // 立刻执行一次，然后重新启动定时器
        setCurrentIndex(prev => prev + 1)
        timerRef.current = setInterval(() => {
          setCurrentIndex(prev => prev + 1)
        }, interval)
      })
    }
  }, [currentIndex, interval])

  // 处理重置后的位置调整
  useEffect(() => {
    if (currentIndex === 0 && wrapperRef.current) {
      // 检查是否需要调整位置（从最后一项跳回第一项）
      const currentTransform = wrapperRef.current.style.transform
      const isAtLastPosition = currentTransform.includes(`${-DATA.length * itemHeight}px`)

      if (isAtLastPosition) {
        // 移除过渡动画
        wrapperRef.current.style.transition = 'none'
        // 立即跳转到第一项位置
        wrapperRef.current.style.transform = `translateY(0px)`
        // 恢复过渡动画
        requestAnimationFrame(() => {
          if (wrapperRef.current) {
            wrapperRef.current.style.transition = ''
          }
        })
      }
    }
  }, [currentIndex, itemHeight])

  // 计算当前显示的位置
  const translateY = -currentIndex * itemHeight

  return (
    <div className='scroll-list-container' style={{ background: gradientColor, width: `${width}px` }} ref={containerRef}>
      <div className='scroll-wrapper' ref={wrapperRef} style={{ transform: `translateY(${translateY}px)` }}>
        {DUPLICATE_DATA.map((item, index) => (
          <div key={index} className='scroll-item' style={{ height: `${itemHeight}px`, color: textColor }}>
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(ScrollList)
